import { useEffect, useState } from 'react';
import CrimsonArcLogoMark from './CrimsonArcLogoMark';

const navLinks = [
  { href: '#services', label: 'Services' },
  { href: '#reach', label: 'Run anywhere' },
  { href: '#verticals', label: 'Business & civic' },
  { href: '#philosophy', label: 'Philosophy' },
  { href: '#clients', label: 'Who we serve' },
  { href: '#mission', label: 'Mission' },
  { href: '#contact', label: 'Contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header
      className={`ca-header ${scrolled ? 'ca-header--scrolled' : ''} ${menuOpen ? 'ca-header--menu-open' : ''}`}
    >
      <div className="ca-header__inner">
        <a href="#top" className="ca-logo" onClick={closeMenu}>
          <span className="ca-logo__mark" aria-hidden>
            <CrimsonArcLogoMark />
          </span>
          <span className="ca-logo__text">CrimsonArc Technologies</span>
        </a>

        <nav className="ca-nav ca-nav--desktop" aria-label="Primary">
          <ul className="ca-nav__list">
            {navLinks.map(({ href, label }) => (
              <li key={href}>
                <a href={href} className="ca-nav__link">
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <a href="#contact" className="ca-btn ca-btn--ghost ca-header__cta" onClick={closeMenu}>
          Start a project
        </a>

        <button
          type="button"
          className={`ca-menu-toggle ${menuOpen ? 'ca-menu-toggle--open' : ''}`}
          aria-expanded={menuOpen}
          aria-controls="mobile-nav"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          onClick={() => setMenuOpen((o) => !o)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div
        id="mobile-nav"
        className={`ca-mobile-nav ${menuOpen ? 'ca-mobile-nav--open' : ''}`}
        aria-hidden={!menuOpen}
      >
        <nav aria-label="Mobile primary">
          <ul className="ca-mobile-nav__list">
            {navLinks.map(({ href, label }) => (
              <li key={href}>
                <a href={href} className="ca-mobile-nav__link" onClick={closeMenu}>
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <a href="#contact" className="ca-btn ca-btn--primary ca-mobile-nav__cta" onClick={closeMenu}>
          Start a project
        </a>
      </div>
    </header>
  );
}
